const {
    GET_ALL_CHAUFFEUR_REQUEST,
    GET_ALL_CHAUFFEUR_SUCCESS,
    GET_ALL_CHAUFFEUR_FAIL,
    ADD_CHAUFFEUR_REQUEST,
    ADD_CHAUFFEUR_SUCCESS,
    ADD_CHAUFFEUR_FAIL,
    UPDATE_CHAUFFEUR_REQUEST,
    UPDATE_CHAUFFEUR_SUCCESS,
    UPDATE_CHAUFFEUR_FAIL,
    DELETE_CHAUFFEUR_REQUEST,
    DELETE_CHAUFFEUR_SUCCESS,
    DELETE_CHAUFFEUR_FAIL
  } = require("../../actionTypes/Paramaetrage/Chauffeur");
  
  function getAllChauffeurs(state = { data: {} }, action) {
    switch (action.type) {
      case GET_ALL_CHAUFFEUR_REQUEST:
        return { loading: true, data: {} };
      case GET_ALL_CHAUFFEUR_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_ALL_CHAUFFEUR_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addChauffeur(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_CHAUFFEUR_REQUEST:
        return { loading: true, data: {} };
      case ADD_CHAUFFEUR_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_CHAUFFEUR_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateChauffeur(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_CHAUFFEUR_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_CHAUFFEUR_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_CHAUFFEUR_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteChauffeur(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_CHAUFFEUR_REQUEST:
        return { loading: true, data: {} };
      case DELETE_CHAUFFEUR_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_CHAUFFEUR_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  export { addChauffeur, updateChauffeur, deleteChauffeur, getAllChauffeurs };
  